import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Columns,
  Column,
  Dialog,
  Stack,
  Text,
  ResponsiveRender
} from '@machobear/design-system'
import { CircleErrorAltLargeIcon } from '@/components/icons'

const MaxAttemptsModal = ({ listingId, history, open, onClose }) => {
  const { t } = useTranslation()

  const handleRequestCode = () => {
    history.push(`/listing/verify/${listingId}`)
    onClose()
  }
  return (
    <Dialog
      id="MaxAttemptsModal"
      illustration={<CircleErrorAltLargeIcon />}
      title={t('l.verify_listing.view.max_attempts_reached.title', 'Maximum attempts reached')}
      open={open}
      onClose={onClose}
      width="xsmall"
    >
      <Stack space="small" align="center">
        <Text>
          {t(
            'l.verify_listing.view.max_attempts_reached.text',
            'You have used up your 5 attempts.'
          )}
        </Text>
        <Text>
          {t('l.verify_listing.view.request_new_code.text', 'Please request a new code.')}
        </Text>
      </Stack>
      <Box paddingTop="large">
        <Columns space="xsmall">
          <ResponsiveRender above="mobile">
            <Column>
              <Button variant="transparent" onClick={onClose}>
                {t('commmon.cancel', 'Cancel')}
              </Button>
            </Column>
          </ResponsiveRender>
          <Column>
            <Button variant="solid" onClick={handleRequestCode}>
              {t('l.verify_listing.view.request_code.button', 'Request code')}
            </Button>
          </Column>
        </Columns>
      </Box>
    </Dialog>
  )
}

export default MaxAttemptsModal
